// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesList_container__7_wn2","highlight":"FeaturesList_highlight__bezes"};